<template>
  <div
    v-if='boxData.judgeBox'
    :style="{
      'top': boxData.fix.y+'px',
      'left': boxData.fix.x+'px',
      'z-index': boxData.Zindex,
      'width'  : !this.boxData.data.vipMsgNone ? '100%' : '470px',
      'border-top'    : !this.boxData.data.vipMsgNone ? (((Window_Size.height - 470) /2) + 'px solid rgba(0,0,0,0)') : '1px solid #d8dee9',
      'border-right'  : !this.boxData.data.vipMsgNone ? (((Window_Size.width - 590) /2) + 'px solid rgba(0,0,0,0)')  : '1px solid #d8dee9',
      'border-bottom' : !this.boxData.data.vipMsgNone ? (((Window_Size.height - 470) /2) + 'px solid rgba(0,0,0,0)') : '1px solid #d8dee9',
      'border-left'   : !this.boxData.data.vipMsgNone ? (((Window_Size.width - 590) /2) + 'px solid rgba(0,0,0,0)')  : '1px solid #d8dee9',
      'background-clip': !this.boxData.data.vipMsgNone ? 'padding-box' : 'inherit',
      'border-radius'  : !this.boxData.data.vipMsgNone ? '0px' : '6px 6px 3px 3px',
      'background'     : !this.boxData.data.vipMsgNone ? 'rgba(0,0,0,0.6)' : '#fff',
    }"
    class="vipEquity"
    @click="stopDocument($event);"
  >
    <div
      class="dragArea"
      v-show="this.boxData.data.vipMsgNone"
      v-on:mousedown="moveStart($event, true)"
      v-on:mousemove="moveArea($event)"
      v-on:mouseup="saveMoveState($event)"
      :style="{
        'cursor': (boxData.moveoks?'move':'default')
      }"
    >
      <span></span>
      <i v-if="boxData.data.hasCloseIcon !== false"class="el-icon-close" @click="close()"></i>
    </div>

    <div
      class="dragArea"
      v-show="!this.boxData.data.vipMsgNone"
    >
      <span></span>
      <i v-if="boxData.data.hasCloseIcon !== false"class="el-icon-close" @click="close()"></i>
    </div>

    <div class="vipEquityBoody">
      <div class="msg" v-if="!this.boxData.data.msgJudge">
          {{this.boxData.data.msg}}
      </div>
      <div class="msgOne" v-if="this.boxData.data.msgJudge == 1">
          {{this.boxData.data.msg}}
      </div>

      <div
        class="second-msg"
        v-if="this.boxData.data.secondMsg"
        v-html="this.boxData.data.secondMsg"
      ></div>

      <div class="vipMsg" v-show="!this.boxData.data.vipMsgNone && this.levelType == 'vip'">

        <div>
          <span style="width: 200px; height: 225px;">
            <img src="../../../../static/svg/normalvip.png" width="100%" height="100%" style="vertical-align: super;"/>
          </span>
        </div>

        <div>
          <span style="width: 200px; height: 225px;">
            <img src="../../../../static/svg/teamvip.png" width="100%" height="100%" style="vertical-align: super;"/>
          </span>
        </div>
      </div>

      <div
        class="vipMsg"
        v-show="!this.boxData.data.vipMsgNone && this.levelType == 'solo'"
        style="justify-content: center;"
      >

        <div>
          <span style="width: 200px; height: 225px;">
            <img src="../../../../static/svg/solo_vip.png" width="100%" height="100%" style="vertical-align: super;"/>
          </span>
        </div>
      </div>

      <div
        class="vipMsg"
        v-show="!this.boxData.data.vipMsgNone && this.levelType == 'vip.s'"
        style="justify-content: center;"
      >

        <div>
          <span style="width: 200px; height: 225px;">
            <img src="../../../../static/svg/normalvip.png" width="100%" height="100%" style="vertical-align: super;"/>
          </span>
        </div>
      </div>

      <div class="btn">

        <div
          class="button button--160"
          :class="{
            'button--secondary' : !this.boxData.data.promptType,
            'button--primary' : this.boxData.data.promptType == 1,
          }"
          v-if="this.boxData.data.btnClose"
          @click="close()"
        >{{this.boxData.data.btnClose}}</div>

        <div
          class="button button--160 button--primary"
          v-if="this.boxData.data.toManage"
          @click="toManage()"
        >{{this.boxData.data.toManage}}</div>

        <a
          :href="boxData.data.link || vipPaymentLink"
          :target="boxData.data.linkTarget != null ? boxData.data.linkTarget : '_blank'"
          v-if="this.boxData.data.btnMsg"
        >

          <div v-if="boxData.data.vipMsgNone">
            <div
              @click="
                refresh();
              "
              class="button button--primary button--160"
              :class="{
              'active' : this.boxData.data.btnClose,
            }">{{this.boxData.data.btnMsg}}</div>
          </div>
          <div
            v-else
            class="button button--primary button--160"
            @click="
              materialPushAnalysis({type: boxData.data.baiduAction});
              getUserMsg();
            "
            :class="{
              'active' : this.boxData.data.btnClose,
          }">{{this.boxData.data.btnMsg}}</div>

        </a>
        <a
          v-if="(this.levelType == 'solo' || this.levelType === 'vip.s') && !boxData.data.noRecommendVip && boxData.data.recommendVip"
          target="_blank"
          href="/workplace/vip"
          style="
            position: absolute;
            bottom: 15px;
            color: #5778fb;
          "
        >{{recommendVip}}</a>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import popupSecond from '../../mixins/popupSecond';
import Analysis from '../../mixins/analysis/materialBu';

export default {
  mixins: [popupSecond, Analysis],
  data () {
    return {
      boxDataName: 'vipEquity', // 弹窗名称
      setIntervalTime: false, // 循环请求变量的保存
      vipPaymentLink: '/workplace/vip', // 跳转链接
      levelType: 'solo',
      recommendVip: '项目容量无限制，点击了解高级会员' // 推荐vip的信息
    };
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'Window_Size',
      'UserEquity',
      'UserLevel',
      'UserMsg'
    ])
  },
  watch: {
    'boxDatas.secondData': function (val, oldval) { // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.secondData, 'vipEquity');
      this.boxData.judgeBox = !(num < 0); // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) { // 打开的操作
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.data = this.dataMsg.vipEquity;
        this.boxData.fix.x = (this.Window_Size.width - 450) / 2;
        this.boxData.fix.y = (this.Window_Size.height - 450) / 2;

        this.levelType = 'levelType' in this.boxData.data
          ? this.boxData.data.levelType
        :          (this.UserMsg.levelType == 0 ? 'solo' : 'vip');

        this.recommendVip = this.boxData.data.recommendVip || '项目容量无限制，点击了解高级会员';

        if (!this.boxData.data.vipMsgNone) {
          this.boxData.fix.x = 0;
          this.boxData.fix.y = 0;
        }

        if (this.boxData.data.btnMsgLink) {
          if (!this.UserEquity.Echart && this.UserEquity.isEchart) {
            this.vipPaymentLink = '/workplace/vip';
          }else {
            this.vipPaymentLink = this.boxData.data.btnMsgLink;
          }
        }
      }
    }
  },
  props: [],
  mounted () {
    this.$bus.on('FeaturesPop_vue', (data) => {
      if (data.name === 'vipEquity') {
        this.boxData.data = data;
      }
    });
  },
  methods: {
    getUserMsg () {
      this.$bus.emit('FeaturesPop_vue', {
        name: 'vipPayment',
        msg: '请在相应的付款页面进行操作',
        btnClose: '遇到问题',
        btnMsg: '付款成功',
        msgType: 0,
        type: 2
      });
      this.close();
    },
    stopDocument (e) { // 防止事件冒泡
      e.stopPropagation();
    },
    refresh () {
      if (this.boxData.data.link === window.location.href) {
        window.location.reload();
      }
    },
    toManage () {
      let link = document.createElement('a');
      link.href = '/manage';
      link.target = '_blank';
      link.click();
    }
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .vipEquity{
    position: fixed;
    top: 0;
    left: 0;
    width: 540px;
    min-height: 150px;
    z-index: 35;
    box-shadow: #d8dee9 0px 0px 5px 0px;
    border-radius: 6px 6px 3px 3px;
    border: 1px solid #d8dee9;
    background: #fff;
    overflow: hidden;
    .vipEquityBoody{
      border-radius: 0px 0px 3px 3px;
      background: #fff;
      .msg{
        width: 378px;
        min-height: 50px;
        margin: 0 auto;
        padding: 40px 0 20px 0;
        font-family: 'Microsoft Yahei';
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #474261;
      }
      .msgOne{
        padding: 70px 0 40px 0;
        font-size: 16px;
        color: #474261;
      }
      .second-msg {
        font-family: 'Microsoft Yahei';
        color: #474261;
      }

      .vipMsg{
        margin-bottom: 34px;
        height: 225px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 75px;

        >div{
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          width: 200px;
          height: 225px;
          >span{
            margin: 0 auto;
          }
        }
      }

      .btn{
        width: 400px;
        height: 87px;
        display: flex;
        margin: 0 auto;
        justify-content: space-around;

        .el-button{
          width: 160px;
          background-color: #eaeaf6;
          font-size: 14px;
          font-size: 14px;
          border-color: #eaeaf6;
          border-radius: 8px;
          height: 39px;

        }
        .active{
          // background-color: #5778fb;
          color: #fff;
        }
      }
    }
    .dragArea{
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 15px;
      height: 28px;
      border-radius: 6px 6px 0px 0px;
      span {
        width: 80px;
        text-align: left;
        color: #474261;
      }
      i {
        display: inline-block;
        width: 18px;
        height: 18px;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/vipPopups/vipEquity.vue